'use strict';
/* @flow */

var _classCallCheck = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _get = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/get");

var _inherits = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var stream = require('readable-stream');

var debug = require('debug');
/* :: import type Multiplex from './index'

export type ChannelOpts = {
  chunked?: bool,
  halfOpen?: bool,
  lazy?: bool
}
*/


var Channel =
/*#__PURE__*/
function (_stream$Duplex) {
  _inherits(Channel, _stream$Duplex);

  function Channel(name
  /* : Buffer | string */
  , plex
  /* : Multiplex */
  , opts
  /* : ChannelOpts = {} */
  ) {
    var _this;

    _classCallCheck(this, Channel);

    var halfOpen = Boolean(opts.halfOpen);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(Channel).call(this, {
      allowHalfOpen: halfOpen
    }));
    _this.name = name;
    _this.log = debug('mplex:channel:' + _this.name.toString());
    _this.channel = 0;
    _this.initiator = false;
    _this.chunked = Boolean(opts.chunked);
    _this.halfOpen = halfOpen;
    _this.destroyed = false;
    _this.finalized = false;
    _this.local = true;
    _this._multiplex = plex;
    _this._dataHeader = 0;
    _this._opened = false;
    _this._awaitDrain = 0;
    _this._lazy = Boolean(opts.lazy);
    var finished = false;
    var ended = false;

    _this.log('open, halfOpen: ' + _this.halfOpen);

    _this.once('end', function () {
      _this.log('end');

      _this._read(); // trigger drain


      if (_this.destroyed) {
        return;
      }

      ended = true;

      if (finished) {
        _this._finalize();
      } else if (!_this.halfOpen) {
        _this.end();
      }
    });

    _this.once('finish', function onfinish() {
      if (this.destroyed) {
        return;
      }

      if (!this._opened) {
        return this.once('open', onfinish);
      }

      if (this._lazy && this.initiator) {
        this._open();
      }

      this._multiplex._send(this.channel << 3 | (this.initiator ? 4 : 3), null);

      finished = true;

      if (ended) {
        this._finalize();
      }
    });

    return _this;
  }
  /**
   * Conditionally emit errors if we have listeners. All other
   * events are sent to EventEmitter.emit
   * @param {string} eventName
   * @param  {...any} args
   * @returns {void}
   */


  _createClass(Channel, [{
    key: "emit",
    value: function emit(eventName) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      if (eventName === 'error' && !this._events.error) {
        this.log.apply(this, ['error'].concat(args));
      } else {
        var _get2;

        (_get2 = _get(_getPrototypeOf(Channel.prototype), "emit", this)).call.apply(_get2, [this, eventName].concat(args));
      }
    }
  }, {
    key: "_destroy",
    value: function _destroy(err
    /* : Error */
    , callback) {
      this.log('_destroy:' + (this.local ? 'local' : 'remote'));

      if (this.local && this._opened) {
        if (this._lazy && this.initiator) {
          this._open();
        }

        var msg = err ? Buffer.from(err.message) : null;

        try {
          this._multiplex._send(this.channel << 3 | (this.initiator ? 6 : 5), msg);
        } catch (e) {
          /* do nothing */
        }
      }

      this._finalize();

      callback(err);
    }
  }, {
    key: "_finalize",
    value: function _finalize() {
      if (this.finalized) {
        return;
      }

      this.finalized = true;
      this.emit('finalize');
    }
  }, {
    key: "_write",
    value: function _write(data
    /* : Buffer */
    , enc
    /* : string */
    , cb
    /* : () => void */
    ) {
      var _this2 = this;

      this.log('write: ', data.length);

      if (!this._opened) {
        this.once('open', function () {
          _this2._write(data, enc, cb);
        });
        return;
      }

      if (this.destroyed) {
        cb();
        return;
      }

      if (this._lazy && this.initiator) {
        this._open();
      }

      var drained = this._multiplex._send(this._dataHeader, data);

      if (drained) {
        cb();
        return;
      }

      this._multiplex._ondrain.push(cb);
    }
  }, {
    key: "_read",
    value: function _read() {
      if (this._awaitDrain) {
        var drained = this._awaitDrain;
        this._awaitDrain = 0;

        this._multiplex._onchanneldrain(drained);
      }
    }
  }, {
    key: "_open",
    value: function _open() {
      var buf = null;

      if (Buffer.isBuffer(this.name)) {
        buf = this.name;
      } else if (this.name !== this.channel.toString()) {
        buf = Buffer.from(this.name);
      }

      this._lazy = false;

      this._multiplex._send(this.channel << 3 | 0, buf);
    }
  }, {
    key: "open",
    value: function open(channel
    /* : number */
    , initiator
    /* : bool */
    ) {
      this.log('open: ' + channel);
      this.channel = channel;
      this.initiator = initiator;
      this._dataHeader = channel << 3 | (initiator ? 2 : 1);
      this._opened = true;
      if (!this._lazy && this.initiator) this._open();
      this.emit('open');
    }
  }]);

  return Channel;
}(stream.Duplex);

module.exports = Channel;